import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { company } from '../../mock';
import { Button } from '../ui/button';

const GetInTouch = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-[2.5rem] bg-brand-blue px-8 py-14 lg:px-16 lg:py-16 text-center">
          <div className="blob w-72 h-72 bg-brand-mint/25 -top-20 -left-10" />
          <div className="blob w-72 h-72 bg-white/10 -bottom-24 -right-10" />
          <div className="relative">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4">Let's find the right care together</h2>
            <p className="font-body text-white/85 max-w-xl mx-auto mb-9">
              Reach out for a free, no-obligation chat. We'll listen first, then help you find the right care or staffing solution.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button asChild className="bg-brand-mint hover:bg-teal-300 text-brand-blue-dark font-semibold h-13 px-8 py-6 rounded-full text-base">
                <Link to="/contact" className="inline-flex items-center gap-2">Get in touch <ArrowRight className="w-4 h-4" /></Link>
              </Button>
              <a href={`tel:${company.primaryPhone}`} className="inline-flex items-center gap-2 text-white font-heading font-semibold hover:text-brand-mint transition-colors duration-200">
                <Phone className="w-5 h-5" /> {company.primaryPhone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
